<button
  class="btn btn-sm"
  type="button"
  (click)="generateAndDownloadTimeSheetTask()"
  [disabled]="isLoading()"
  ngbTooltip="Download timesheet"
  i18n-ngbTooltip="tooltip|Tooltip for download timesheet@@downloadTaskButtonTitle"
>
  @if (!isLoading()) {
    <i class="bi bi-download"></i>
  } @else {
    <span class="spinner-border spinner-border-sm"></span>
  }
</button>
